export interface MuuttujanLisays {
  teksti: string
  kohdistin: number
}

export function lisaaMuuttujaTekstiin(teksti: string, valinnanAlku: number | null, valinnanLoppu: number | null, muuttuja: string): MuuttujanLisays {
  const tekstiEnnen = teksti.slice(0, valinnanAlku)
  const tekstiJalkeen = teksti.slice(valinnanLoppu)
  const tarvitaankoValilyonti = tekstiEnnen.length > 0 && !tekstiEnnen.endsWith(' ') && !tekstiEnnen.endsWith('\n')
  const lisattava = tarvitaankoValilyonti ? ` ${muuttuja}` : muuttuja
  return { teksti: tekstiEnnen + lisattava + tekstiJalkeen, kohdistin: (tekstiEnnen + lisattava).length }
}
